import React, {useEffect, useState} from 'react'
import {message, Modal, Table} from "antd"
import {getMemberClubLevel, getMemberClubLevelRecord} from "../../../../../api/clubMemberList"
import moment from 'moment'

const ClubMemberFindLevel = ({memberId}) => {
    const [isShow, setIsShow] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [memberRecord, setMemberRecord] = useState([])
    const [queryParams, setQueryParams] = useState({
        accountId: memberId,
        page: 1,
        count: 10,
    })
    const [total, setTotal] = useState(0)

    useEffect(() => {
        fetchMemberLevelRecord().then()
    }, [queryParams])

    const fetchMemberLevelRecord = async () => {
        setIsLoading(true)
        await getMemberClubLevelRecord(queryParams).then(res => {
            if (res.status === 1) {
                setTotal(res.data.total)
                setMemberRecord(res.data.values)
                return
            }
            message.error(`获取会员等级失败：${res.detail}`)
        }).catch(err => {
            message.error(`获取会员等级失败：${err.message}`)
        }).finally(()=>{
            setIsLoading(false)
        })
    }


    const handleClick = async () => {
        setIsShow(true)
        await fetchMemberLevelRecord()
    }

    const columns = [
        {
            title: '俱乐部名称',
            dataIndex: 'clubName',
            key: 'clubName',            
        },
        {
            title: '原来折扣',
            dataIndex: 'realLevelName',
            key: 'realLevelName',
            width: 120
        },
        {
            title: '当前折扣',
            dataIndex: 'afterLevelName',
            key: 'afterLevelName',
            width: 120
        },
        {
            title: '操作人ID',
            dataIndex: 'operatorId',
            key: 'operatorId',
            width: 120
        },
        {
            title: '操作人',
            dataIndex: 'operatorName',
            key: 'operatorName',
            width: 120
        },
        {
            title: '操作人手机号',
            dataIndex: 'operatorAccount',
            key: 'operatorAccount',
            width: 160, 
        },
        {
            title: '操作时间',
            dataIndex: 'updateTime',
            key: 'updateTime',
            width: 160,            
            render: (text) => {
                return moment(text).format('YYYY-MM-DD HH:mm:ss')
            },            
        },
        {
            title: '来源',
            dataIndex: 'originType',
            key: 'originType',
            width: 120, 
            render: (text) => {
                switch (text) {
                    case -1:
                        return '未知'
                    case 0:
                        return '平台'
                    case 1:
                        return '收银端'
                    case 2:
                        return '老板端'
                    case 3:
                        return '管理后台'
                    default:
                        break
                }
            }
        }
    ]

    return (
        <div>
            <div onClick={handleClick}>等级足迹</div>
            <Modal
                open={isShow}
                onCancel={() => setIsShow(false)}
                width={1200}
                destroyOnClose
                title={"等级足迹"}
                footer={null}
            >
                <Table
                    columns={columns}
                    loading={isLoading}
                    dataSource={memberRecord}
                    pagination={{
                        total: total
                    }}
                    onChange={(pagination) => setQueryParams(prevState => {
                        return {
                            ...prevState,
                            page: pagination.current || 1,
                        }
                    })}
                />
            </Modal>
        </div>
    )
}

export default ClubMemberFindLevel


// WEBPACK FOOTER //
// ./src/containers/ClubMemberList/component/ClubMemberFind/component/ClubMemberFindLevel.js